import React from "react";
import CssClasses from "./MostPlayedButton.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

const MostPlayedButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  let iconName = "";
  let iconClass = "";

  if (props.icon === "fire") {
    iconName = SiteIcons.site_icon_fire;
    iconClass = CssClasses.iconFire;
  } else if (props.icon === "star") {
    iconName = SiteIcons.site_icon_star;
    iconClass = CssClasses.iconStar;
  } else if (props.icon === "crown") {
    iconName = SiteIcons.site_icon_crown;
    iconClass = CssClasses.iconCrown;
  } else if (props.icon === "chalice") {
    iconName = SiteIcons.site_icon_chalice;
    iconClass = CssClasses.iconChalice;
  } else if (props.icon === "plus") {
    iconName = SiteIcons.site_icon_plus;
    iconClass = CssClasses.iconPlus;
  }

  var iconClasses = [iconName, iconClass, CssClasses.legendIcon];
  var arrowClasses = [
    SiteIcons.site_icon_arrow,
    CssClasses.iconArrow,
    CssClasses.legendIcon
  ];

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      <span className={iconClasses.join(" ")} />
      <span className={CssClasses.text}>{props.title}</span>
      <span className={arrowClasses.join(" ")} />
    </div>
  );
};

export default MostPlayedButton;



// WEBPACK FOOTER //
// ./src/Components/UI/MostPlayedButton/MostPlayedButton.js